// Libellés des codes culture Télépac (RPG). Codes les plus courants ; sinon on garde le code brut.
export const CROP_LABELS = {
  BTH: "Blé tendre d'hiver",
  BTP: "Blé tendre de printemps",
  BDH: "Blé dur d'hiver",
  BDP: "Blé dur de printemps",
  ORH: "Orge d'hiver",
  ORP: "Orge de printemps",
  AVH: "Avoine d'hiver",
  AVP: "Avoine de printemps",
  SGH: "Seigle d'hiver",
  TTH: "Triticale d'hiver",
  TTP: "Triticale de printemps",
  MIS: "Maïs grain",
  MIE: "Maïs ensilage",
  CZH: "Colza d'hiver",
  CZP: "Colza de printemps",
  TRN: "Tournesol",
  SOJ: "Soja",
  FVL: "Féverole",
  FVP: "Féverole de printemps",
  PH: "Pois",
  PHI: "Pois d'hiver",
  PPR: "Pois de printemps",
  LIH: "Lin",
  LIP: "Lin de printemps",
  BTN: "Betterave",
  PTC: "Pomme de terre",
  LUZ: "Luzerne",
  SRS: "Sorgho",
  PPH: "Prairie permanente",
  PTR: "Prairie temporaire",
  PRL: "Prairie en rotation longue",
  SPL: "Surface pastorale",
  JAC: "Jachère",
  J5M: "Jachère (5 ans ou plus)",
  J6S: "Jachère (6 mois)",
  CGH: "Cultures conduites en bandes",
  FVT: "Fourrage",
};

export function cropLabel(code) {
  if (!code) return "";
  const c = code.toString().trim().toUpperCase();
  return CROP_LABELS[c] || c;
}
